module.exports = __webpack_public_path__ + "static/media/company_logo.93c92bab.svg";